import { DataObject } from "@lib/titan2/dist/api/core/data/DataObject";
import { FishFoodChanceGameData, GoldFishChanceGameData, GreenFishChanceGameData, PurpleFishChanceGameData, RedFishChanceGameData } from "./ChanceGamesData";
import { SlotsGameData } from "./SlotsGameData";
/**
 * FeatureTestData.ts
 */
export class FeatureTestData {
}
FeatureTestData.GREEN_FISH = {
    getChanceGame: () => new GreenFishChanceGameData(new DataObject({
        "id": 39,
        "gameConfig": {
            "id": "chance-greenfish"
        },
        "games": [
            {
                "id": 40,
                "gameConfig": {
                    "id": "pick-bubble",
                    "multiplier": 1
                },
                "payout": [
                    7
                ],
                "stake": 2,
                "totalWin": 7,
                "currencyCode": "GBP",
                "params": {
                    "missed": [
                        7,
                        12,
                        5,
                        4,
                        5,
                        -1,
                        8,
                        5
                    ]
                }
            }
        ],
        "payout": [],
        "stake": 2,
        "totalWin": 7,
        "currencyCode": "GBP",
        "params": {}
    })),
    getSlotsGame: () => new SlotsGameData(new DataObject({
        "gameId": "slots-irishxxxtreme-cap10k",
        "completionReason": "NO_PURCHASE_SPIN",
        "completionDate": 1673962201385,
        "standardSpins": 1,
        "standardSpinsUsed": 1,
        "standardSpinsRemaining": 0,
        "freeSpins": 12,
        "freeSpinsUsed": 12,
        "freeSpinsRemaining": 0,
        "totalStake": 0.2,
        "totalWin": 11.6,
        "currencyCode": "GBP"
    })),
    getSlotsSpins: () => []
};
FeatureTestData.GREEN_FISH_COLLECT_ALL = {
    getChanceGame: () => new GreenFishChanceGameData(new DataObject({
        "id": 50,
        "gameConfig": {
            "id": "chance-greenfish"
        },
        "games": [
            {
                "id": 51,
                "gameConfig": {
                    "id": "chance-collect-all",
                    "multiplier": 1
                },
                "payout": [
                    1.0,
                    2.0,
                    3.0,
                    4.0,
                    5.0,
                    6.0,
                    8.0,
                    10.0
                ],
                "stake": 2.0,
                "totalWin": 39.0,
                "currencyCode": "GBP",
                "params": {}
            }
        ],
        "payout": [],
        "stake": 2.0,
        "totalWin": 39.0,
        "currencyCode": "GBP",
        "params": {}
    })),
    getSlotsGame: () => new SlotsGameData(new DataObject({
        "gameId": "slots-irishxxxtreme-cap10k",
        "completionReason": "NO_PURCHASE_SPIN",
        "completionDate": 1673962201385,
        "standardSpins": 1,
        "standardSpinsUsed": 1,
        "standardSpinsRemaining": 0,
        "freeSpins": 12,
        "freeSpinsUsed": 12,
        "freeSpinsRemaining": 0,
        "totalStake": 0.2,
        "totalWin": 11.6,
        "currencyCode": "GBP"
    })),
    getSlotsSpins: () => []
};
FeatureTestData.RED_FISH_2 = {
    getChanceGame: () => new RedFishChanceGameData(new DataObject({
        "id": 1866,
        "gameConfig": {
            "id": "chance-redfish"
        },
        "games": [
            {
                "id": 1867,
                "gameConfig": {
                    "id": "normal-initial-pick",
                    "multiplier": 1
                },
                "payout": [],
                "stake": 25,
                "totalWin": 0,
                "currencyCode": "GBP",
                "params": {}
            },
            {
                "id": 1868,
                "gameConfig": {
                    "id": "normal-initial-pick",
                    "multiplier": 1
                },
                "payout": [],
                "stake": 25,
                "totalWin": 0,
                "currencyCode": "GBP",
                "params": {}
            }
        ],
        "payout": [
            100,
            100,
            0
        ],
        "stake": 25,
        "totalWin": 400,
        "currencyCode": "GBP",
        "params": {
            "total": "3",
            "type": [
                "initial",
                "purple",
                "gold"
            ],
            "misses": [
                {
                    "id": 1,
                    "gameConfig": {
                        "id": "level1bag",
                        "multiplier": 1,
                        "picks": 2
                    },
                    "winMultiplier": 1,
                    "multipliers": [
                        2
                    ],
                    "wins": [
                        50
                    ],
                    "totalWin": 50,
                    "weight": 21
                },
                {
                    "id": 3,
                    "gameConfig": {
                        "id": "level1bag",
                        "multiplier": 1,
                        "picks": 2
                    },
                    "winMultiplier": 1,
                    "multipliers": [
                        4
                    ],
                    "wins": [
                        100
                    ],
                    "totalWin": 100,
                    "weight": 249
                }
            ]
        }
    })),
    getSlotsGame: () => new SlotsGameData(new DataObject({
        "gameId": "slots-irishxxxtreme-cap10k",
        "completionReason": "NO_PURCHASE_SPIN",
        "completionDate": 1673962201385,
        "standardSpins": 1,
        "standardSpinsUsed": 1,
        "standardSpinsRemaining": 0,
        "freeSpins": 12,
        "freeSpinsUsed": 12,
        "freeSpinsRemaining": 0,
        "totalStake": 0.2,
        "totalWin": 11.6,
        "currencyCode": "GBP"
    })),
    getSlotsSpins: () => []
};
FeatureTestData.RED_FISH = {
    getChanceGame: () => new RedFishChanceGameData(new DataObject({
        "id": 215,
        "gameConfig": {
            "id": "chance-redfish"
        },
        "games": [
            {
                "id": 216,
                "gameConfig": {
                    "id": "normal-initial-pick",
                    "multiplier": 1
                },
                "payout": [],
                "stake": 1,
                "totalWin": 0,
                "currencyCode": "GBP",
                "params": {}
            },
            {
                "id": 217,
                "gameConfig": {
                    "id": "normal-initial-pick",
                    "multiplier": 1
                },
                "payout": [],
                "stake": 1,
                "totalWin": 0,
                "currencyCode": "GBP",
                "params": {}
            }
        ],
        "payout": [
            3,
            2,
            2,
            10
        ],
        "stake": 1,
        "totalWin": 17,
        "currencyCode": "GBP",
        "params": {
            "total": "3",
            "type": [
                "initial",
                "purple",
                "green",
                "purple"
            ],
            "misses": [
                {
                    "id": 3,
                    "gameConfig": {
                        "id": "level1bag",
                        "multiplier": 1,
                        "picks": 2
                    },
                    "winMultiplier": 1,
                    "multipliers": [
                        4
                    ],
                    "wins": [
                        4
                    ],
                    "totalWin": 4,
                    "weight": 236
                },
                {
                    "id": 3,
                    "gameConfig": {
                        "id": "level1bag",
                        "multiplier": 1,
                        "picks": 2
                    },
                    "winMultiplier": 1,
                    "multipliers": [
                        4
                    ],
                    "wins": [
                        4
                    ],
                    "totalWin": 4,
                    "weight": 227
                }
            ]
        }
    })),
    getSlotsGame: () => new SlotsGameData(new DataObject({
        "gameId": "slots-irishxxxtreme-cap10k",
        "completionReason": "NO_PURCHASE_SPIN",
        "completionDate": 1673962201385,
        "standardSpins": 1,
        "standardSpinsUsed": 1,
        "standardSpinsRemaining": 0,
        "freeSpins": 12,
        "freeSpinsUsed": 12,
        "freeSpinsRemaining": 0,
        "totalStake": 0.2,
        "totalWin": 11.6,
        "currencyCode": "GBP"
    })),
    getSlotsSpins: () => []
};
FeatureTestData.RED_FISH_ERROR = {
    getChanceGame: () => new RedFishChanceGameData(new DataObject({
        "id": 2369,
        "gameConfig": {
            "id": "chance-redfish"
        },
        "games": [
            {
                "id": 2370,
                "gameConfig": {
                    "id": "normal-initial-pick",
                    "multiplier": 1
                },
                "payout": [],
                "stake": 1.0,
                "totalWin": 0,
                "currencyCode": "GBP",
                "params": {}
            },
            {
                "id": 2371,
                "gameConfig": {
                    "id": "normal-initial-pick",
                    "multiplier": 1
                },
                "payout": [],
                "stake": 1.0,
                "totalWin": 0,
                "currencyCode": "GBP",
                "params": {}
            }
        ],
        "payout": [
            4.0,
            1.0,
            2.0
        ],
        "stake": 1.0,
        "totalWin": 11.0,
        "currencyCode": "GBP",
        "params": {
            "total": "3",
            "type": [
                "initial",
                "green",
                "green",
                "blue|purple|green"
            ],
            "misses": [
                {
                    "id": 3,
                    "gameConfig": {
                        "id": "level1bag",
                        "multiplier": 1,
                        "picks": 2
                    },
                    "winMultiplier": 1,
                    "multipliers": [
                        4
                    ],
                    "wins": [
                        4.0
                    ],
                    "totalWin": 4.0,
                    "weight": 263
                },
                {
                    "id": 2,
                    "gameConfig": {
                        "id": "level1bag",
                        "multiplier": 1,
                        "picks": 2
                    },
                    "winMultiplier": 1,
                    "multipliers": [
                        3
                    ],
                    "wins": [
                        3.0
                    ],
                    "totalWin": 3.0,
                    "weight": 128
                }
            ]
        }
    })),
    getSlotsGame: () => new SlotsGameData(new DataObject({
        "gameId": "slots-irishxxxtreme-cap10k",
        "completionReason": "NO_PURCHASE_SPIN",
        "completionDate": 1673962201385,
        "standardSpins": 1,
        "standardSpinsUsed": 1,
        "standardSpinsRemaining": 0,
        "freeSpins": 12,
        "freeSpinsUsed": 12,
        "freeSpinsRemaining": 0,
        "totalStake": 0.2,
        "totalWin": 11.6,
        "currencyCode": "GBP"
    })),
    getSlotsSpins: () => []
};
FeatureTestData.PURPLE_FISH = {
    getChanceGame: () => new PurpleFishChanceGameData(new DataObject({
        "id": 6940,
        "gameId": "chance-purplefish",
        "gameConfig": {
            "id": "chance-purplefish"
        },
        "games": [
            {
                "id": 6943,
                "gameId": "chance-purplefish-mode",
                "gameConfig": {
                    "id": "chance-purplefish-mode",
                    "multiplier": 1
                },
                "games": [
                    {
                        "id": 6942,
                        "gameId": "chance-purplefish-regularInitialValue",
                        "gameConfig": {
                            "id": "chance-purplefish-regularInitialValue",
                            "multiplier": 1
                        },
                        "games": [
                            {
                                "id": 6941,
                                "gameId": "pick-purplefish-regularMultipliers",
                                "gameConfig": {
                                    "id": "pick-purplefish-regularMultipliers",
                                    "multiplier": 0.1
                                },
                                "payout": [
                                    0.1,
                                    2,
                                    30
                                ],
                                "stake": 0.1,
                                "totalWin": 3.21,
                                "currencyCode": "GBP",
                                "params": {}
                            }
                        ],
                        "payout": [],
                        "stake": 0.1,
                        "totalWin": 3.21,
                        "currencyCode": "GBP",
                        "params": {}
                    }
                ],
                "payout": [],
                "stake": 0.1,
                "totalWin": 3.21,
                "currencyCode": "GBP",
                "params": {}
            },
            {
                "id": 6944,
                "gameId": "chance-purplefish-regularInitialValue",
                "gameConfig": {
                    "id": "chance-purplefish-regularInitialValue",
                    "multiplier": 1
                },
                "payout": [],
                "stake": 0.1,
                "totalWin": 0,
                "currencyCode": "GBP",
                "params": {}
            },
            {
                "id": 6945,
                "gameId": "chance-purplefish-highInitialValue",
                "gameConfig": {
                    "id": "chance-purplefish-highInitialValue",
                    "multiplier": 1
                },
                "payout": [],
                "stake": 0.1,
                "totalWin": 0,
                "currencyCode": "GBP",
                "params": {}
            }
        ],
        "payout": [],
        "stake": 0.1,
        "totalWin": 3.21,
        "currencyCode": "GBP",
        "params": {
            "misses": [
                {
                    "id": 7,
                    "gameConfig": {
                        "id": "pick-purplefish-highMultipliers",
                        "multiplier": 0.3,
                        "picks": 3
                    },
                    "winMultiplier": 1,
                    "totalWin": 0,
                    "weight": 600
                },
                {
                    "id": 9,
                    "gameConfig": {
                        "id": "pick-purplefish-highMultipliers",
                        "multiplier": 1,
                        "picks": 3
                    },
                    "winMultiplier": 1,
                    "totalWin": 0,
                    "weight": 1000
                }
            ]
        }
    })),
    getSlotsGame: () => new SlotsGameData(new DataObject({
        "gameId": "slots-irishxxxtreme-cap10k",
        "completionReason": "NO_PURCHASE_SPIN",
        "completionDate": 1673962201385,
        "standardSpins": 1,
        "standardSpinsUsed": 1,
        "standardSpinsRemaining": 0,
        "freeSpins": 12,
        "freeSpinsUsed": 12,
        "freeSpinsRemaining": 0,
        "totalStake": 0.2,
        "totalWin": 11.6,
        "currencyCode": "GBP"
    })),
    getSlotsSpins: () => []
};
FeatureTestData.FISH_FOOD = {
    getChanceGame: () => new FishFoodChanceGameData(new DataObject({
        "id": 2957,
        "gameConfig": {
            "id": "pick-fishfood-3"
        },
        "games": [
            {
                "id": 2958,
                "gameConfig": {
                    "id": "pick-turtle",
                    "multiplier": 1
                },
                "payout": [
                    2
                ],
                "stake": 1,
                "totalWin": 0,
                "currencyCode": "GBP",
                "params": {
                    "misses": [
                        3,
                        5
                    ]
                }
            }
        ],
        "payout": [
            0,
            2,
            0,
            2,
            1,
            0
        ],
        "stake": 1,
        "totalWin": 2,
        "currencyCode": "GBP",
        "params": {
            "type": [
                "Turtle",
                "Purple",
                "Turtle",
                "Purple",
                "Green",
                "Turtle"
            ],
            "multiplier": 1,
            "fishFoodPrizes": {
                "Red": 3,
                "Gold": 8,
                "Turtle": 0,
                "Blue": 4,
                "Purple": 2,
                "Green": 1
            }
        }
    })),
    getSlotsGame: () => new SlotsGameData(new DataObject({
        "gameId": "slots-irishxxxtreme-cap10k",
        "completionReason": "NO_PURCHASE_SPIN",
        "completionDate": 1673962201385,
        "standardSpins": 1,
        "standardSpinsUsed": 1,
        "standardSpinsRemaining": 0,
        "freeSpins": 12,
        "freeSpinsUsed": 12,
        "freeSpinsRemaining": 0,
        "totalStake": 0.2,
        "totalWin": 11.6,
        "currencyCode": "GBP"
    })),
    getSlotsSpins: () => []
};
FeatureTestData.FISH_FOOD_GOLDEN_TURTLE = {
    getChanceGame: () => new FishFoodChanceGameData(new DataObject({
        "id": 71,
        "gameConfig": {
            "id": "pick-fishfood-1"
        },
        "games": [
            {
                "id": 72,
                "gameConfig": {
                    "id": "pick-turtle",
                    "multiplier": 150
                },
                "payout": [
                    300
                ],
                "stake": 1,
                "totalWin": 0,
                "currencyCode": "GBP",
                "params": {
                    "misses": [
                        450,
                        750
                    ]
                }
            }
        ],
        "payout": [
            120,
            60,
            45,
            30,
            15,
            120,
            60,
            45,
            30,
            15,
            120,
            60,
            45,
            30,
            15,
            120,
            60,
            45,
            30,
            15
        ],
        "stake": 1,
        "totalWin": 840,
        "currencyCode": "GBP",
        "params": {
            "type": [
                "Gold",
                "Blue",
                "Red",
                "Purple",
                "Green",
                "Gold",
                "Blue",
                "Red",
                "Purple",
                "Green",
                "Gold",
                "Blue",
                "Red",
                "Purple",
                "Green",
                "Gold",
                "Blue",
                "Red",
                "Purple",
                "Green"
            ],
            "multiplier": 15,
            "fishFoodPrizes": {
                "Red": 45,
                "Gold": 120,
                "Turtle": 0,
                "Blue": 60,
                "Purple": 30,
                "Green": 15
            }
        }
    })),
    getSlotsGame: () => new SlotsGameData(new DataObject({
        "gameId": "slots-irishxxxtreme-cap10k",
        "completionReason": "NO_PURCHASE_SPIN",
        "completionDate": 1673962201385,
        "standardSpins": 1,
        "standardSpinsUsed": 1,
        "standardSpinsRemaining": 0,
        "freeSpins": 12,
        "freeSpinsUsed": 12,
        "freeSpinsRemaining": 0,
        "totalStake": 0.2,
        "totalWin": 11.6,
        "currencyCode": "GBP"
    })),
    getSlotsSpins: () => []
};
FeatureTestData.FISH_FOOD_FULL_HOUSE = {
    getChanceGame: () => new FishFoodChanceGameData(new DataObject({
        "id": 2977,
        "gameConfig": {
            "id": "pick-fishfood-3"
        },
        "games": [
            {
                "id": 2978,
                "gameConfig": {
                    "id": "pick-turtle",
                    "multiplier": 15
                },
                "payout": [
                    60
                ],
                "stake": 2,
                "totalWin": 0,
                "currencyCode": "GBP",
                "params": {
                    "misses": [
                        90,
                        150
                    ]
                }
            }
        ],
        "payout": [
            0,
            240,
            30,
            120,
            240,
            60,
            90,
            90,
            240,
            60,
            30,
            240,
            90,
            30,
            60,
            60,
            0,
            120,
            0
        ],
        "stake": 2,
        "totalWin": 780,
        "currencyCode": "GBP",
        "params": {
            "type": [
                "Turtle",
                "Gold",
                "Green",
                "Blue",
                "Gold",
                "Purple",
                "Red",
                "Red",
                "Gold",
                "Purple",
                "Green",
                "Gold",
                "Red",
                "Green",
                "Purple",
                "Purple",
                "Turtle",
                "Blue",
                "Turtle"
            ],
            "multiplier": 15,
            "fishFoodPrizes": {
                "Red": 90,
                "Gold": 240,
                "Turtle": 0,
                "Blue": 120,
                "Purple": 60,
                "Green": 30
            }
        }
    })),
    getSlotsGame: () => new SlotsGameData(new DataObject({
        "gameId": "slots-irishxxxtreme-cap10k",
        "completionReason": "NO_PURCHASE_SPIN",
        "completionDate": 1673962201385,
        "standardSpins": 1,
        "standardSpinsUsed": 1,
        "standardSpinsRemaining": 0,
        "freeSpins": 12,
        "freeSpinsUsed": 12,
        "freeSpinsRemaining": 0,
        "totalStake": 0.2,
        "totalWin": 11.6,
        "currencyCode": "GBP"
    })),
    getSlotsSpins: () => []
};
FeatureTestData.GOLD_FISH = {
    getChanceGame: () => new GoldFishChanceGameData(new DataObject({
        "id": 146,
        "gameConfig": {
            "id": "chance-goldfish-low"
        },
        "payout": [
            0,
            0,
            3,
            0,
            0,
            0,
            5,
            0,
            2,
            2,
            2,
            0,
            5,
            0,
            0,
            0,
            2,
            0,
            0,
            0,
            0,
            2,
            3,
            0,
            0,
            0,
            3,
            0,
            3,
            0,
            3,
            0,
            3,
            3,
            0,
            2,
            2,
            0,
            0,
            0,
            5,
            2,
            5,
            3,
            2,
            0,
            0,
            0,
            0,
            5,
            0,
            0,
            0,
            1,
            2,
            0,
            0,
            3,
            0,
            2,
            3,
            0,
            0,
            0,
            0,
            0
        ],
        "stake": 1,
        "totalWin": 78,
        "currencyCode": "GBP",
        "params": {
            "initialGoldFish": 1,
            "initialPicks": 8,
            "goldfish": 1,
            "size": 5,
            "missedBubbles": [
                {
                    "totalPicks": 9,
                    "totalGoldFish": 1
                },
                {
                    "totalPicks": 8,
                    "totalGoldFish": 2
                },
                {
                    "totalPicks": 10,
                    "totalGoldFish": 1
                },
                {
                    "totalPicks": 11,
                    "totalGoldFish": 1
                },
            ],
            "picks": 12,
            "bonusGameData": [
                {
                    "spinType": "freespin",
                    "spinWin": 3,
                    "reel": [
                        0,
                        3,
                        0,
                        0,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "RED",
                        "BLANK",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 1,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 1,
                    "spinsRemaining": 11,
                    "currentSpin": 1,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 11,
                    "reel": [
                        5,
                        0,
                        2,
                        2,
                        2
                    ],
                    "type": [
                        "PURPLE",
                        "BLANK",
                        "GREEN",
                        "GREEN",
                        "GREEN"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 1,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 1,
                    "spinsRemaining": 10,
                    "currentSpin": 2,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 5,
                    "reel": [
                        0,
                        5,
                        0,
                        0,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "PURPLE",
                        "BLANK",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 1,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 1,
                    "spinsRemaining": 9,
                    "currentSpin": 3,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 2,
                    "reel": [
                        2,
                        0,
                        0,
                        0,
                        0
                    ],
                    "type": [
                        "GREEN",
                        "BLANK",
                        "BLANK",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 1,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 1,
                    "spinsRemaining": 8,
                    "currentSpin": 4,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 5,
                    "reel": [
                        2,
                        3,
                        0,
                        0,
                        0
                    ],
                    "type": [
                        "GREEN",
                        "RED",
                        "BLANK",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 1,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 1,
                    "spinsRemaining": 7,
                    "currentSpin": 5,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 9,
                    "reel": [
                        3,
                        0,
                        3,
                        0,
                        3
                    ],
                    "type": [
                        "RED",
                        "BLANK",
                        "RED",
                        "BLANK",
                        "RED"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 1,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 1,
                    "spinsRemaining": 6,
                    "currentSpin": 6,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 8,
                    "reel": [
                        0,
                        3,
                        3,
                        0,
                        2
                    ],
                    "type": [
                        "BLANK",
                        "RED",
                        "RED",
                        "BLANK",
                        "GREEN"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 1,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 1,
                    "spinsRemaining": 5,
                    "currentSpin": 7,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 7,
                    "reel": [
                        2,
                        0,
                        0,
                        0,
                        5
                    ],
                    "type": [
                        "GREEN",
                        "BLANK",
                        "BLANK",
                        "BLANK",
                        "PURPLE"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 1,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 1,
                    "spinsRemaining": 4,
                    "currentSpin": 8,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 12,
                    "reel": [
                        2,
                        5,
                        3,
                        2,
                        0
                    ],
                    "type": [
                        "GREEN",
                        "PURPLE",
                        "RED",
                        "GREEN",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 1,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 1,
                    "spinsRemaining": 3,
                    "currentSpin": 9,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 5,
                    "reel": [
                        0,
                        0,
                        0,
                        5,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "BLANK",
                        "BLANK",
                        "PURPLE",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 1,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 1,
                    "spinsRemaining": 2,
                    "currentSpin": 10,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 3,
                    "reel": [
                        0,
                        0,
                        1,
                        2,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "BLANK",
                        "BLUE",
                        "GREEN",
                        "BLANK"
                    ],
                    "blueFishCounter": 1,
                    "goldFishCounter": 1,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 1,
                    "spinsRemaining": 1,
                    "currentSpin": 11,
                    "respinTriggered": true
                },
                {
                    "spinType": "respin",
                    "spinWin": 8,
                    "reel": [
                        0,
                        3,
                        0,
                        2,
                        3
                    ],
                    "type": [
                        "BLANK",
                        "RED",
                        "BLANK",
                        "GREEN",
                        "RED"
                    ],
                    "blueFishCounter": 1,
                    "goldFishCounter": 1,
                    "blueFishCounterBeforeSpin": 1,
                    "goldFishCounterBeforeSpin": 1,
                    "spinsRemaining": 1,
                    "currentSpin": 11,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 0,
                    "reel": [
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "GOLD",
                        "BLANK",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 2,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 1,
                    "spinsRemaining": 0,
                    "currentSpin": 12,
                    "respinTriggered": false
                }
            ],
            "type": "BLANK"
        }
    })),
    getSlotsGame: () => new SlotsGameData(new DataObject({
        "gameId": "slots-irishxxxtreme-cap10k",
        "completionReason": "NO_PURCHASE_SPIN",
        "completionDate": 1673962201385,
        "standardSpins": 1,
        "standardSpinsUsed": 1,
        "standardSpinsRemaining": 0,
        "freeSpins": 12,
        "freeSpinsUsed": 12,
        "freeSpinsRemaining": 0,
        "totalStake": 0.2,
        "totalWin": 11.6,
        "currencyCode": "GBP"
    })),
    getSlotsSpins: () => []
};
FeatureTestData.GOLD_FISH_COLLECTOR = {
    getChanceGame: () => new GoldFishChanceGameData(new DataObject({
        "id": 156,
        "gameConfig": {
            "id": "chance-goldfish-low"
        },
        "payout": [
            0,
            0,
            3,
            0,
            2,
            0,
            0,
            0,
            2,
            0,
            2,
            3,
            1,
            3,
            0,
            0,
            3,
            3,
            3,
            0,
            2,
            2,
            2,
            0,
            0,
            0,
            3,
            0,
            5,
            0,
            0,
            0,
            0,
            2,
            0,
            5,
            2,
            5,
            0,
            0,
            2,
            0,
            0,
            5,
            0,
            2
        ],
        "stake": 1,
        "totalWin": 124,
        "currencyCode": "GBP",
        "params": {
            "initialGoldFish": 1,
            "initialPicks": 8,
            "goldfish": 2,
            "size": 5,
            "missedBubbles": [
                {
                    "totalPicks": 9,
                    "totalGoldFish": 1
                },
                {
                    "totalPicks": 10,
                    "totalGoldFish": 1
                },
                {
                    "totalPicks": 11,
                    "totalGoldFish": 1
                },
                {
                    "totalPicks": 12,
                    "totalGoldFish": 1
                }
            ],
            "picks": 8,
            "bonusGameData": [
                {
                    "spinType": "freespin",
                    "spinWin": 10,
                    "reel": [
                        0,
                        3,
                        0,
                        2,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "RED",
                        "BLANK",
                        "GREEN",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 2,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 2,
                    "spinsRemaining": 7,
                    "currentSpin": 1,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 8,
                    "reel": [
                        0,
                        0,
                        2,
                        0,
                        2
                    ],
                    "type": [
                        "BLANK",
                        "BLANK",
                        "GREEN",
                        "BLANK",
                        "GREEN"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 2,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 2,
                    "spinsRemaining": 6,
                    "currentSpin": 2,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 14,
                    "reel": [
                        3,
                        1,
                        3,
                        0,
                        0
                    ],
                    "type": [
                        "RED",
                        "BLUE",
                        "RED",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 1,
                    "goldFishCounter": 2,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 2,
                    "spinsRemaining": 5,
                    "currentSpin": 3,
                    "respinTriggered": true
                },
                {
                    "spinType": "respin",
                    "spinWin": 22,
                    "reel": [
                        3,
                        3,
                        3,
                        0,
                        2
                    ],
                    "type": [
                        "RED",
                        "RED",
                        "RED",
                        "BLANK",
                        "GREEN"
                    ],
                    "blueFishCounter": 1,
                    "goldFishCounter": 2,
                    "blueFishCounterBeforeSpin": 1,
                    "goldFishCounterBeforeSpin": 2,
                    "spinsRemaining": 5,
                    "currentSpin": 3,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 8,
                    "reel": [
                        2,
                        2,
                        0,
                        0,
                        0
                    ],
                    "type": [
                        "GREEN",
                        "GREEN",
                        "BLANK",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 2,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 2,
                    "spinsRemaining": 4,
                    "currentSpin": 4,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 16,
                    "reel": [
                        3,
                        0,
                        5,
                        0,
                        0
                    ],
                    "type": [
                        "RED",
                        "BLANK",
                        "PURPLE",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 2,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 2,
                    "spinsRemaining": 3,
                    "currentSpin": 5,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 14,
                    "reel": [
                        0,
                        0,
                        2,
                        0,
                        5
                    ],
                    "type": [
                        "BLANK",
                        "BLANK",
                        "GREEN",
                        "BLANK",
                        "PURPLE"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 2,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 2,
                    "spinsRemaining": 2,
                    "currentSpin": 6,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 18,
                    "reel": [
                        2,
                        5,
                        0,
                        0,
                        2
                    ],
                    "type": [
                        "GREEN",
                        "PURPLE",
                        "BLANK",
                        "BLANK",
                        "GREEN"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 2,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 2,
                    "spinsRemaining": 1,
                    "currentSpin": 7,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 14,
                    "reel": [
                        0,
                        0,
                        5,
                        0,
                        2
                    ],
                    "type": [
                        "BLANK",
                        "BLANK",
                        "PURPLE",
                        "BLANK",
                        "GREEN"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 2,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 2,
                    "spinsRemaining": 0,
                    "currentSpin": 8,
                    "respinTriggered": false
                }
            ],
            "type": "GREEN"
        }
    })),
    getSlotsGame: () => new SlotsGameData(new DataObject({
        "gameId": "slots-irishxxxtreme-cap10k",
        "completionReason": "NO_PURCHASE_SPIN",
        "completionDate": 1673962201385,
        "standardSpins": 1,
        "standardSpinsUsed": 1,
        "standardSpinsRemaining": 0,
        "freeSpins": 12,
        "freeSpinsUsed": 12,
        "freeSpinsRemaining": 0,
        "totalStake": 0.2,
        "totalWin": 11.6,
        "currencyCode": "GBP"
    })),
    getSlotsSpins: () => []
};
FeatureTestData.GOLD_FISH_SPIN_COLLECTOR = {
    getChanceGame: () => new GoldFishChanceGameData(new DataObject({
        "id": 162,
        "gameConfig": {
            "id": "chance-goldfish-low"
        },
        "payout": [
            0,
            0,
            0,
            0,
            3,
            0,
            0,
            5,
            0,
            0,
            0,
            2,
            2,
            0,
            3,
            2,
            5,
            0,
            3,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            3,
            0,
            0,
            0,
            5,
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            2,
            2,
            0,
            2,
            0,
            0
        ],
        "stake": 1,
        "totalWin": 98,
        "currencyCode": "GBP",
        "params": {
            "initialGoldFish": 1,
            "initialPicks": 8,
            "goldfish": 1,
            "size": 5,
            "missedBubbles": [
                {
                    "totalPicks": 10,
                    "totalGoldFish": 1
                },
                {
                    "totalPicks": 11,
                    "totalGoldFish": 1
                },
                {
                    "totalPicks": 12,
                    "totalGoldFish": 1
                },
                {
                    "totalPicks": 8,
                    "totalGoldFish": 2
                }
            ],
            "picks": 9,
            "bonusGameData": [
                {
                    "spinType": "freespin",
                    "spinWin": 6,
                    "reel": [
                        0,
                        0,
                        0,
                        3,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "BLANK",
                        "BLANK",
                        "RED",
                        "GOLD"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 2,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 1,
                    "spinsRemaining": 8,
                    "currentSpin": 1,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 10,
                    "reel": [
                        0,
                        5,
                        0,
                        0,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "PURPLE",
                        "BLANK",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 2,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 2,
                    "spinsRemaining": 7,
                    "currentSpin": 2,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 18,
                    "reel": [
                        2,
                        2,
                        0,
                        3,
                        2
                    ],
                    "type": [
                        "GREEN",
                        "GREEN",
                        "BLANK",
                        "RED",
                        "GREEN"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 2,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 2,
                    "spinsRemaining": 6,
                    "currentSpin": 3,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 16,
                    "reel": [
                        5,
                        0,
                        3,
                        0,
                        0
                    ],
                    "type": [
                        "PURPLE",
                        "BLANK",
                        "RED",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 2,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 2,
                    "spinsRemaining": 5,
                    "currentSpin": 4,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 0,
                    "reel": [
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "BLANK",
                        "BLANK",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 2,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 2,
                    "spinsRemaining": 4,
                    "currentSpin": 5,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 9,
                    "reel": [
                        0,
                        0,
                        3,
                        0,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "BLANK",
                        "RED",
                        "GOLD",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 3,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 2,
                    "spinsRemaining": 3,
                    "currentSpin": 6,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 21,
                    "reel": [
                        0,
                        5,
                        2,
                        0,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "PURPLE",
                        "GREEN",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 3,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 3,
                    "spinsRemaining": 2,
                    "currentSpin": 7,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 6,
                    "reel": [
                        0,
                        0,
                        0,
                        0,
                        2
                    ],
                    "type": [
                        "BLANK",
                        "BLANK",
                        "BLANK",
                        "BLANK",
                        "GREEN"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 3,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 3,
                    "spinsRemaining": 1,
                    "currentSpin": 8,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 12,
                    "reel": [
                        2,
                        0,
                        2,
                        0,
                        0
                    ],
                    "type": [
                        "GREEN",
                        "BLANK",
                        "GREEN",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 3,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 3,
                    "spinsRemaining": 0,
                    "currentSpin": 9,
                    "respinTriggered": false
                }
            ],
            "type": "BLANK"
        }
    })),
    getSlotsGame: () => new SlotsGameData(new DataObject({
        "gameId": "slots-irishxxxtreme-cap10k",
        "completionReason": "NO_PURCHASE_SPIN",
        "completionDate": 1673962201385,
        "standardSpins": 1,
        "standardSpinsUsed": 1,
        "standardSpinsRemaining": 0,
        "freeSpins": 12,
        "freeSpinsUsed": 12,
        "freeSpinsRemaining": 0,
        "totalStake": 0.2,
        "totalWin": 11.6,
        "currencyCode": "GBP"
    })),
    getSlotsSpins: () => []
};
FeatureTestData.GOLD_FISH_FH_BLUE_MULTIPLIER_COLLECTION = {
    getChanceGame: () => new GoldFishChanceGameData(new DataObject({
        "id": 867,
        "gameConfig": {
            "id": "chance-goldfish-high"
        },
        "payout": [
            0,
            0,
            1,
            1,
            5,
            0,
            1,
            0,
            1,
            5,
            2,
            0,
            2,
            1,
            5,
            2,
            0,
            2,
            0,
            5,
            2,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2,
            0,
            0,
            0,
            1,
            3,
            0,
            0,
            2,
            0,
            3,
            2,
            0,
            2,
            0,
            0,
            0,
            2,
            0,
            0,
            3,
            0,
            0,
            0,
            0,
            0,
            3,
            3,
            0,
            0,
            0,
            0
        ],
        "stake": 1,
        "totalWin": 710,
        "currencyCode": "GBP",
        "params": {
            "initialGoldFish": 2,
            "initialPicks": 8,
            "goldfish": 3,
            "size": 5,
            "missedBubbles": [
                {
                    "totalPicks": 9,
                    "totalGoldFish": 2
                },
                {
                    "totalPicks": 10,
                    "totalGoldFish": 2
                },
                {
                    "totalPicks": 11,
                    "totalGoldFish": 2
                },
                {
                    "totalPicks": 12,
                    "totalGoldFish": 2
                }
            ],
            "picks": 8,
            "bonusGameData": [
                {
                    "spinType": "freespin",
                    "spinWin": 56,
                    "reel": [
                        0,
                        1,
                        1,
                        5,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "BLUE",
                        "BLUE",
                        "PURPLE",
                        "GOLD"
                    ],
                    "blueFishCounter": 2,
                    "goldFishCounter": 4,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 3,
                    "spinsRemaining": 7,
                    "currentSpin": 1,
                    "respinTriggered": true
                },
                {
                    "spinType": "respin",
                    "spinWin": 144,
                    "reel": [
                        1,
                        0,
                        1,
                        5,
                        2
                    ],
                    "type": [
                        "BLUE",
                        "BLANK",
                        "BLUE",
                        "PURPLE",
                        "GREEN"
                    ],
                    "blueFishCounter": 4,
                    "goldFishCounter": 4,
                    "blueFishCounterBeforeSpin": 2,
                    "goldFishCounterBeforeSpin": 4,
                    "spinsRemaining": 7,
                    "currentSpin": 1,
                    "respinTriggered": true
                },
                {
                    "spinType": "respin",
                    "spinWin": 200,
                    "reel": [
                        0,
                        2,
                        1,
                        5,
                        2
                    ],
                    "type": [
                        "BLANK",
                        "GREEN",
                        "BLUE",
                        "PURPLE",
                        "GREEN"
                    ],
                    "blueFishCounter": 5,
                    "goldFishCounter": 4,
                    "blueFishCounterBeforeSpin": 4,
                    "goldFishCounterBeforeSpin": 4,
                    "spinsRemaining": 7,
                    "currentSpin": 1,
                    "respinTriggered": true
                },
                {
                    "spinType": "respin",
                    "spinWin": 180,
                    "reel": [
                        0,
                        2,
                        0,
                        5,
                        2
                    ],
                    "type": [
                        "BLANK",
                        "GREEN",
                        "BLANK",
                        "PURPLE",
                        "GREEN"
                    ],
                    "blueFishCounter": 5,
                    "goldFishCounter": 4,
                    "blueFishCounterBeforeSpin": 5,
                    "goldFishCounterBeforeSpin": 4,
                    "spinsRemaining": 7,
                    "currentSpin": 1,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 0,
                    "reel": [
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "BLANK",
                        "GOLD",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 5,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 4,
                    "spinsRemaining": 6,
                    "currentSpin": 2,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 10,
                    "reel": [
                        0,
                        0,
                        0,
                        2,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "BLANK",
                        "BLANK",
                        "GREEN",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 5,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 5,
                    "spinsRemaining": 5,
                    "currentSpin": 3,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 20,
                    "reel": [
                        0,
                        0,
                        1,
                        3,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "BLANK",
                        "BLUE",
                        "RED",
                        "BLANK"
                    ],
                    "blueFishCounter": 1,
                    "goldFishCounter": 5,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 5,
                    "spinsRemaining": 4,
                    "currentSpin": 4,
                    "respinTriggered": true
                },
                {
                    "spinType": "respin",
                    "spinWin": 35,
                    "reel": [
                        0,
                        2,
                        0,
                        3,
                        2
                    ],
                    "type": [
                        "BLANK",
                        "GREEN",
                        "BLANK",
                        "RED",
                        "GREEN"
                    ],
                    "blueFishCounter": 1,
                    "goldFishCounter": 5,
                    "blueFishCounterBeforeSpin": 1,
                    "goldFishCounterBeforeSpin": 5,
                    "spinsRemaining": 4,
                    "currentSpin": 4,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 10,
                    "reel": [
                        0,
                        2,
                        0,
                        0,
                        0
                    ],
                    "type": [
                        "BLANK",
                        "GREEN",
                        "BLANK",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 5,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 5,
                    "spinsRemaining": 3,
                    "currentSpin": 5,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 25,
                    "reel": [
                        2,
                        0,
                        0,
                        3,
                        0
                    ],
                    "type": [
                        "GREEN",
                        "BLANK",
                        "BLANK",
                        "RED",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 5,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 5,
                    "spinsRemaining": 2,
                    "currentSpin": 6,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 15,
                    "reel": [
                        0,
                        0,
                        0,
                        0,
                        3
                    ],
                    "type": [
                        "BLANK",
                        "BLANK",
                        "BLANK",
                        "BLANK",
                        "RED"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 5,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 5,
                    "spinsRemaining": 1,
                    "currentSpin": 7,
                    "respinTriggered": false
                },
                {
                    "spinType": "freespin",
                    "spinWin": 15,
                    "reel": [
                        3,
                        0,
                        0,
                        0,
                        0
                    ],
                    "type": [
                        "RED",
                        "BLANK",
                        "BLANK",
                        "BLANK",
                        "BLANK"
                    ],
                    "blueFishCounter": 0,
                    "goldFishCounter": 5,
                    "blueFishCounterBeforeSpin": 0,
                    "goldFishCounterBeforeSpin": 5,
                    "spinsRemaining": 0,
                    "currentSpin": 8,
                    "respinTriggered": false
                }
            ],
            "type": "BLANK"
        }
    })),
    getSlotsGame: () => new SlotsGameData(new DataObject({
        "gameId": "slots-irishxxxtreme-cap10k",
        "completionReason": "NO_PURCHASE_SPIN",
        "completionDate": 1673962201385,
        "standardSpins": 1,
        "standardSpinsUsed": 1,
        "standardSpinsRemaining": 0,
        "freeSpins": 12,
        "freeSpinsUsed": 12,
        "freeSpinsRemaining": 0,
        "totalStake": 0.2,
        "totalWin": 11.6,
        "currencyCode": "GBP"
    })),
    getSlotsSpins: () => []
};
//# sourceMappingURL=FeatureTestData.js.map